/**
 * API-allowed sort fields for the building list.
 * Matches BuildingListParams.sort allowed values: address, createdAt, name, status.
 */
export const BuildingListSortField = {
    Name: 'name',
    Address: 'address',
    Status: 'status',
    CreatedAt: 'createdAt',
} as const;

export type BuildingListSortField =
    (typeof BuildingListSortField)[keyof typeof BuildingListSortField];
